import { useL10n } from '@uplift/hooks';
import { useStyles } from './provider-card.styles';
import { ProviderCardViewProps } from './provider-card.component';
import { ContactInfoRow, StackableCard } from '@uplift/ui-v2';
import { Box, Typography } from '@mui/material';
import { ProviderAvatar } from './provider-card-avatar.component';
import { AccountCircleOutlined, TodayOutlined } from '@mui/icons-material';
import { ProviderMedicalRole } from '@uplift/types';
import { clientScheduleSessionRoute, ROUTING_CONFIG } from '@uplift/constants';
import { useProviderPublicMatchingProfile } from '@uplift/queries';
import { useCanScheduleWithProvider } from '../../../hooks/use-can-schedule-with-provider';

export const ProviderCardMobile: React.VFC<ProviderCardViewProps> = ({ providerType, userName, provider, matchId }) => {
  const l10n = useL10n();
  const { classes } = useStyles();
  const { canSchedule } = useCanScheduleWithProvider(provider.id, { suspense: true });
  const { data: publicProfile } = useProviderPublicMatchingProfile(provider.id, { enabled: !!provider?.id, suspense: true });

  return (
    <StackableCard className={classes.mobileCard}>
      <Box className={classes.info}>
        <ProviderAvatar src={publicProfile?.avatarAsset?.url} size={56} />
        <Box className={classes.rightBlock}>
          <Box className={classes.nameLine}>
            <Typography variant="h6" className={classes.fullNameText}>
              {userName}
            </Typography>
            {publicProfile.profile.pronouns && (
              <Typography variant="body1">
                ({publicProfile.profile.pronouns})
              </Typography>
            )}
          </Box>
          <Typography color="textSecondary">
            {l10n.resources.provider.types[providerType]}
          </Typography>
        </Box>
      </Box>
      <ContactInfoRow
        icon={AccountCircleOutlined}
        primary={l10n.general.viewProfile}
        type="link"
        text={`${ROUTING_CONFIG.careTeam}/${provider.id}`}
      />
      {canSchedule && (
        <ContactInfoRow
          icon={TodayOutlined}
          primary="Schedule Session"
          type="link"
          text={clientScheduleSessionRoute.createLink({ providerId: provider.id })}
        />
      )}
      {provider.medicalRole === ProviderMedicalRole.therapist && (
        <ContactInfoRow
          primary={l10n.requestRematch.findANewTherapist}
          iconSpacer
          type="link"
          text={`/rematching/${matchId}`}
        />
      )}
    </StackableCard>
  );
};
